export const JAZZ_LOADING_MESSAGES = [
  'Searching for the "Lost" Coltrane tapes in the attic...',
  'Rehearsing the jazz face for the bridge...',
  'Avoiding butter notes...',
  'Taking a big breath...',
  'Checking if the metronome is judging us...',
  'Counting "one e and a two e and a"...',
  'Warming up the left hand...',
  'Making sure the piano is in tune (it\'s not)...',
  'Blaming the drummer for the latency...',
  'Finding the groove before the downbeat...',
] as const;

export type AppLoadingStage =
  | 'auth:loading'
  | 'auth:waiting_sso'
  | 'auth:redirecting'
  | 'sso:processing';

export const STAGE_LABELS: Record<AppLoadingStage, string> = {
  'auth:loading': 'Restoring your session...',
  'auth:waiting_sso': 'Completing sign-in...',
  'auth:redirecting': 'Redirecting to login...',
  'sso:processing': 'Signing you in...',
};
